import { ApiService } from './api.service';
import { GrowingPurpose } from '@/models/student/growing-purpose';

class GrowingPurposeService extends ApiService {
  constructor() {
    super();
  }

  getGrowingPurposesList(): Promise<GrowingPurpose[]> {
    return this.getList(GrowingPurpose, '/master/growingPurposes', {});
  }

  getValidGrowingPurposesList(isValid: number = 1): Promise<GrowingPurpose[]> {
    return this.getList(GrowingPurpose, '/master/growingPurposes', { isValid });
  }
}

export const growingPurposeService = new GrowingPurposeService();
